import { useInfiniteQuery } from '@tanstack/react-query';

import AccountHistoryClient from '@clients/accountHistoryClient';
import notifyAPIError from '@utils/notifyAPIError';

const { getAccountHistory } = AccountHistoryClient();

export type AccountHistoryProps = {
    accountId: string;
    customerId: string;
};

const useGetAccountHistory = ({
    accountId,
    customerId,
}: AccountHistoryProps) => {
    const { data, error, isError, isLoading, fetchNextPage, hasNextPage } =
        useInfiniteQuery(
            ['customerHistoryDetails', accountId, customerId],
            ({ pageParam }) =>
                getAccountHistory({
                    accountId: parseFloat(accountId),
                    customerId: parseFloat(customerId),
                    page: pageParam,
                    perPage: 25,
                }),
            {
                getNextPageParam: (lastPage) =>
                    lastPage.next_page ? lastPage.current_page + 1 : undefined,
                onError: notifyAPIError,
            },
        );
    return {
        data,
        error,
        isError,
        isLoading,
        fetchNextPage,
        hasNextPage,
    };
};

export default useGetAccountHistory;
